module.exports = __webpack_public_path__ + "static/media/info-popup.7f95c780.png";